import React, { ComponentProps } from 'react'
import SvgIcon from '@mui/material/SvgIcon'

export const GoogleCalendarLogo = ({ width = 24, height = 24, ...restProps }: ComponentProps<typeof SvgIcon>) => (
  <SvgIcon {...restProps} viewBox={`0 0 ${width} ${height}`}>
    <path d="M17.5 6.5H6.5V17.5H17.5V6.5Z" fill="white" />
    <path d="M12.84 10.4601L13.344 11.1801L14.136 10.6041V14.7801H15V9.30811H14.28L12.84 10.4601Z" fill="#1E88E5" />
    <path
      d="M11.4715 11.8726C11.784 11.5856 11.978 11.1876 11.978 10.7481C11.978 9.87456 11.2115 9.16406 10.2695 9.16406C9.4685 9.16406 8.7835 9.66856 8.6045 10.3906L9.433 10.6011C9.5155 10.2691 9.867 10.0281 10.2695 10.0281C10.7405 10.0281 11.124 10.3511 11.124 10.7481C11.124 11.1451 10.7405 11.4681 10.2695 11.4681H9.771V12.3321H10.2695C10.81 12.3321 11.266 12.7076 11.266 13.1521C11.266 13.6041 10.833 13.9721 10.3005 13.9721C9.8195 13.9721 9.4085 13.6671 9.3435 13.2631L8.5 13.4011C8.631 14.2191 9.405 14.8361 10.3 14.8361C11.3035 14.8361 12.12 14.0806 12.12 13.1521C12.12 12.6406 11.868 12.1816 11.4715 11.8726Z"
      fill="#1E88E5"
    />
    <path d="M17 21H7L6.5 19L7 17H17L17.5 19L17 21Z" fill="#FBC02D" />
    <path d="M19 17.5L21 17V7L19 6.5L17 7V17L19 17.5Z" fill="#4CAF50" />
    <path d="M17 7L17.5 5L17 3H4.5C3.6715 3 3 3.6715 3 4.5V17L5 17.5L7 17V7H17Z" fill="#1E88E5" />
    <path d="M17 17V21L21 17H17Z" fill="#E53935" />
    <path d="M19.5 3H17V7H21V4.5C21 3.6715 20.3285 3 19.5 3Z" fill="#1565C0" />
    <path d="M4.5 21H7V17H3V19.5C3 20.3285 3.6715 21 4.5 21Z" fill="#1565C0" />
  </SvgIcon>
)
